import React, { useState } from "react";
import Modal from "../../../../atoms/Popup/Popup";
import { CANCEL_REASONS } from "../../constants";
import "./CancelSessionModal.scss";

type Props = {
  isOpen: boolean;
  sessionTitle?: string;
  submitting?: boolean;
  onClose: () => void;
  onConfirm: (payload: { reason: string; note: string }) => void;
};

const CancelSessionModal: React.FC<Props> = ({
  isOpen,
  sessionTitle,
  submitting,
  onClose,
  onConfirm,
}) => {
  const [reason, setReason] = useState("");
  const [note, setNote] = useState("");

  const handleClose = () => {
    setReason("");
    setNote("");
    onClose();
  };

  return (
    <Modal
      show={isOpen}
      headerText="Cancel session"
      onClose={handleClose}
      placement="top"
      size="sm"
    >
      <div className="wf-cancel-modal">
        {sessionTitle ? (
          <p className="wf-cancel-modal__lead">
            Cancel <strong>{sessionTitle}</strong>? Members who were reminded
            will be notified.
          </p>
        ) : null}
        <label className="wf-field">
          <span>
            Reason <span className="req">*</span>
          </span>
          <select value={reason} onChange={(e) => setReason(e.target.value)}>
            <option value="">Select a reason</option>
            {CANCEL_REASONS.map((r) => (
              <option key={r} value={r}>
                {r}
              </option>
            ))}
          </select>
        </label>
        <label className="wf-field">
          <span>Internal note (optional)</span>
          <textarea
            rows={3}
            value={note}
            maxLength={240}
            onChange={(e) => setNote(e.target.value)}
            placeholder="Anything the team should know"
          />
        </label>
        <div className="wf-cancel-modal__actions">
          <button
            type="button"
            className="wf-btn ghost"
            onClick={handleClose}
            disabled={submitting}
          >
            Keep session
          </button>
          <button
            type="button"
            className="wf-btn danger"
            disabled={!reason || submitting}
            onClick={() => onConfirm({ reason, note })}
          >
            {submitting ? "Cancelling…" : "Cancel session"}
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default CancelSessionModal;
